module.exports = __webpack_public_path__ + "img/trading-pic1.5b3dc11c.png";